export default class RwEvents {
    static OpenSnackBar = "OPEN_SNACKBAR";
    static Logout = "LOGOUT";
    static RouteRefresh = "RT_REFRESH";
    static StopUpdate = "STP_UPDATE";
    static MapReRender = "MAP_RERENDER";
}
